import { motion } from "framer-motion";
import { Stamp } from "@/components/fronk/Stamp";
import { SceneVideo } from "@/components/fronk/SceneVideo";

const fadeUp = {
  initial: { opacity: 0, y: 18 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
};

export const NightShift = () => {
  return (
    <section
      id="night-shift"
      className="navy-grain relative overflow-hidden bg-[color:var(--ink-900)] py-16 sm:py-20 lg:py-28"
      data-testid="night-shift-section"
    >
      <div className="relative z-10 mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
        <motion.div {...fadeUp}>
          <Stamp>Third shift report</Stamp>
          <h2 className="font-heading mt-5 text-3xl font-bold leading-tight text-[color:var(--paper-0)] sm:text-4xl lg:text-5xl">
            THE OFFICE NEVER CLOSES
          </h2>
          <p className="font-body mt-4 max-w-xl text-base leading-relaxed text-[color:var(--paper-1)]">
            The tubes hum through the night. The building breathes. Somewhere
            on the seventh floor a lamp is still on and one more form is
            getting stamped.
          </p>
        </motion.div>

        <motion.div {...fadeUp} className="mt-10">
          <SceneVideo
            src="/fronk/motion/fronk-hq-breathing-loop.mp4"
            poster="/fronk/scenes/fronk-hq-night.webp"
            posterMobile="/fronk/scenes/fronk-hq-night-mobile.webp"
            className="ink-frame aspect-[4/5] rounded-2xl sm:aspect-[1862/845]"
            alt="FRONK headquarters at night, a frog shaped building with glowing windows and coin tubes"
            testId="night-shift-video"
          />
          <p className="font-mono-ledger mt-3 text-[10px] uppercase tracking-[0.2em] text-[color:var(--brass-200)]">
            Fig. 2. Headquarters, 3:12 am. All floors reporting normal froth.
          </p>
        </motion.div>

        <div className="mt-10 grid gap-5 md:grid-cols-2">
          <motion.figure {...fadeUp} className="group">
            <div className="ink-frame overflow-hidden rounded-2xl">
              <img
                src="/fronk/scenes/fronk-elevator.webp"
                alt="A packed elevator full of tired Pepe employees"
                className="aspect-[16/9] w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                loading="lazy"
              />
            </div>
            <figcaption className="font-mono-ledger mt-3 text-[10px] uppercase tracking-[0.18em] text-[color:var(--paper-1)]">
              The 7:58 elevator. Standing room only since listing day.
            </figcaption>
          </motion.figure>
          <motion.figure {...fadeUp} className="group">
            <div className="ink-frame overflow-hidden rounded-2xl">
              <img
                src="/fronk/scenes/pepe-boardroom.webp"
                alt="The Pepe boardroom in session"
                className="aspect-[16/9] w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                loading="lazy"
              />
            </div>
            <figcaption className="font-mono-ledger mt-3 text-[10px] uppercase tracking-[0.18em] text-[color:var(--paper-1)]">
              Board minutes. Item one. Tubes. Item two. Tubes again.
            </figcaption>
          </motion.figure>
        </div>
      </div>
    </section>
  );
};
